import { useRemoveMealFromSlot } from "@/hooks/requests/plan/use-remove-meal-from-slot";
import { useToast } from "@/hooks/ui/use-toast";
import { planAdjustmentIntentAtom } from "@/stores/plan-adjustment-modal.store";
import { useAtom } from "jotai";
import { memo, useCallback } from "react";
import { SwapPlanAdjustmentModal } from "../swap-plan-adjustment-modal";

export const PlanAdjustmentModalContainer = memo(function PlanAdjustmentModalContainer() {
  const [intent, setIntent] = useAtom(planAdjustmentIntentAtom);
  const { removeMealFromSlotAsync, isLoading: isUndoing } = useRemoveMealFromSlot();
  const { showError, showInfo } = useToast();

  const handleDismiss = useCallback(() => {
    setIntent(null);
  }, [setIntent]);

  const handleUndo = useCallback(async () => {
    if (!intent || intent.kind !== "add-meal-to-slot") {
      return;
    }

    try {
      await removeMealFromSlotAsync({
        day: intent.day,
        mealTime: intent.mealTime,
        meal_id: intent.mealId,
        targetDate: intent.targetDate ?? undefined,
      });
      showInfo("Meal removed", { duration: 5000 });
      setIntent(null);
    } catch (error) {
      const message = error instanceof Error ? error.message : "Failed to undo. Please try again.";
      showError(message);
    }
  }, [intent, removeMealFromSlotAsync, setIntent, showError, showInfo]);

  return (
    <SwapPlanAdjustmentModal
      isOpen={intent !== null}
      onDismiss={handleDismiss}
      onConfirm={handleDismiss}
      onUndoSwap={handleUndo}
      isUndoing={isUndoing}
      canUndo={intent?.canUndo ?? false}
      undoLabel="Undo"
    />
  );
});
